<template>
    <HelloWorld msg="Welcome to Your Foo App"/>   
</template>
<script>
import HelloWorld from './HelloWorld.vue'

export default {
  name: 'Foo',
  components: {
    HelloWorld
  }
}
</script>